import { render, staticRenderFns } from "./LoadingWithRelative.vue?vue&type=template&id=7568590c&lang=pug&"
import script from "./LoadingWithRelative.vue?vue&type=script&lang=ts&"
export * from "./LoadingWithRelative.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingWithRelative.vue?vue&type=style&index=0&id=7568590c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports